<template>
  <div id="app" v-bind:class="{ desktop: desktop, app: app }">
    <app-auth ref="auth"></app-auth>
    <div class="app-container">
      <app-topheader ref="topheader"></app-topheader>
      <app-wrapper></app-wrapper>
    </div>
    <app-message />
    <app-invitation id="invitation" />
    <app-payment-lock id="payment-lock" />
    <app-QRCode ref="qrcode" id="qrcode-modal" />
    <app-QRCode-ServiceCall
      ref="qrcodeServiceCall"
      id="qrcode-servicecall-modal"
    />
    <app-payment id="payment"></app-payment>
    <app-ClientsLoader />
    <app-PrintersLoader />
  </div>
</template>

<script>
import Auth from "./Auth.vue";
import TopHeader from "./TopHeader.vue";
import Wrapper from "./Wrapper.vue";
import Message from "./Message.vue";
import Invitation from "./Invitation.vue";
import QRCode from "./QRCode.vue";
import QRCodeServiceCall from "./QRCode-ServiceCall.vue";
import PaymentLock from "./PaymentLock.vue";
import Payment from "./Payment.vue";
import ClientsLoader from "./ClientsLoader.vue";
import PrintersLoader from "./PrintersLoader.vue";

import utils from "intl-tel-input/build/js/utils.js";

import "bootstrap/dist/css/bootstrap.css";
require("popper.js/dist/umd/popper.js");
require("bootstrap/dist/js/bootstrap.js");

import "material-design-lite/dist/material.light_blue-blue.min.css";
require("material-design-lite/material.js");

var ClipboardJS = require("clipboard/dist/clipboard.js");

jQuery.event.special.touchstart = {
  setup: function(_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  }
};

$(window).on("load", function() {
  $(window).trigger("resize");
  window.scrollTo(0, 1);
});

var langParser = require("accept-language-parser");

import { mapState } from "vuex";
export default {
  name: "app",
  computed: {
    ...mapState({
      desktop: state => state.user.desktop,
      app: state => state.user.app,
      ref: state => state.user.ref
    })
  },
  methods: {
    setTooltip: function(trigger, message) {
      $(trigger).tooltip({
        placement: "top",
        trigger: "click"
      });
      setTimeout(function() {
        $(trigger)
          .tooltip("hide")
          .attr("data-original-title", message)
          .tooltip("show");
      }, 250);
    },
    hideTooltip: function(trigger) {
      setTimeout(function() {
        $(trigger).tooltip("hide");
      }, 2000);
    }
  },
  created() {
    var _this = this;
    var lang = null;
    const printer = _this.getUrlParameter("printer");
    const clientUser = _this.getUrlParameter("user");
    window.$store = _this.$store;
    if (clientUser) {
      this.$store.dispatch("user/set_property", {
        property: "clientUser",
        value: clientUser
      });
    }
    if (printer) {
      this.$store.dispatch("user/set_property", {
        property: "printer",
        value: true
      });
    }
    if (window.location.hostname.includes("desktop")) {
      this.$store.dispatch("user/set_property", {
        property: "desktop",
        value: true
      });
    }
    if (window.location.hostname.includes("app")) {
      this.$store.dispatch("user/set_property", {
        property: "app",
        value: true
      });
    }

    var clipboard = new ClipboardJS(".copy");

    // clipboard.on("success", function(e) {
    //   _this.setTooltip(e.trigger, _this.t("Copied!"));
    //   _this.hideTooltip(e.trigger);
    // });

    clipboard.on("error", function(e) {
      _this.setTooltip(e.trigger, _this.t("Failed!"));
      _this.hideTooltip(e.trigger);
    });

    // get lang from user on firestore.

    var url_string = window.location.href;
    var url = new URL(url_string);
    var lang = url.searchParams.get("lang");

    var getLang = function(lang) {
      switch (lang) {
        case "pt":
          break;
        default:
          lang = "en";
      }
      return lang;
    };

    if (lang) {
      lang = getLang(lang);
      // intercomSettings['language_override'] = lang;
      _this.$i18n.locale = lang;
      console.log(lang);
    } else {
      $.get("https://api.maprinter.com/service?request=getHeaders", function(
        response
      ) {
        var languages = langParser.parse(response["accept-language"]);
        lang = languages[0].code;
        lang = getLang(lang);
        _this.$i18n.locale = lang;
        // intercomSettings['language_override'] = lang;
        // Intercom('update', intercomSettings);
      });
    }
  },
  components: {
    "app-auth": Auth,
    "app-topheader": TopHeader,
    "app-wrapper": Wrapper,
    "app-message": Message,
    "app-invitation": Invitation,
    "app-payment-lock": PaymentLock,
    "app-QRCode": QRCode,
    "app-QRCode-ServiceCall": QRCodeServiceCall,
    "app-payment": Payment,
    "app-ClientsLoader": ClientsLoader,
    "app-PrintersLoader": PrintersLoader
  }
};

require("../style/scss/app.scss");
</script>

<style lang="scss" scoped>
#app {
  // padding-bottom: 85px;
  #app-auth {
    display: none;
  }
  #app-auth {
    padding-top: 15vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue